import { useEffect, useState } from "react";
import { api } from "../lib/api";

export interface Company {
  id: number;
  name: string;
  short_code: string;
  default_language: "en" | "th";
  currency: string;
  reply_to_email: string | null;
}

const LS_KEY = "pc_company_id";

export function useCurrentCompany() {
  const [companies, setCompanies] = useState<Company[]>([]);
  const [companyId, _setCompanyId] = useState<number | null>(() => {
    const raw = localStorage.getItem(LS_KEY);
    return raw ? Number(raw) : null;
  });

  useEffect(() => {
    api<{ companies: Company[] }>("/api/companies").then((r) => {
      setCompanies(r.companies);
      if (!companyId && r.companies.length) {
        _setCompanyId(r.companies[0].id);
        localStorage.setItem(LS_KEY, String(r.companies[0].id));
      }
    }).catch(() => {});
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  function setCompanyId(id: number) {
    _setCompanyId(id);
    localStorage.setItem(LS_KEY, String(id));
  }

  const current = companies.find((c) => c.id === companyId) || null;
  return { companies, current, companyId, setCompanyId };
}

export default function CompanySwitcher() {
  const { companies, current, companyId, setCompanyId } = useCurrentCompany();
  if (!companies.length) return null;
  return (
    <div className="flex items-center rounded-lg border border-indigo-200/80 bg-indigo-50/70 pl-3 pr-1 shadow-soft ring-1 ring-indigo-100/50">
      <span className="text-[10px] font-semibold uppercase tracking-wider text-indigo-700/80">
        Acting as
      </span>
      <div className="relative ml-2">
        <select
          value={companyId ?? ""}
          onChange={(e) => setCompanyId(Number(e.target.value))}
          className="min-w-[20rem] cursor-pointer appearance-none !border-0 !bg-transparent !pl-2 pr-9 text-sm font-semibold !text-indigo-900 shadow-none !ring-0 focus:!ring-0"
          aria-label="Active company"
        >
          {companies.map((c) => (
            <option key={c.id} value={c.id}>{c.name}</option>
          ))}
        </select>
        <svg className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-indigo-500" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fillRule="evenodd" d="M10 13a.75.75 0 01-.53-.22l-3.75-3.75a.75.75 0 111.06-1.06L10 11.19l3.22-3.22a.75.75 0 111.06 1.06l-3.75 3.75A.75.75 0 0110 13z" clipRule="evenodd" />
        </svg>
      </div>
    </div>
  );
}
